/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateConversationTitleDto
 */
export interface UpdateConversationTitleDto {
    /**
     * New title for the conversation. If not provided, a title will be auto-generated based on the first user message.
     * @type {string}
     * @memberof UpdateConversationTitleDto
     */
    title?: string;
}

/**
 * Check if a given object implements the UpdateConversationTitleDto interface.
 */
export function instanceOfUpdateConversationTitleDto(value: object): value is UpdateConversationTitleDto {
    return true;
}

export function UpdateConversationTitleDtoFromJSON(json: any): UpdateConversationTitleDto {
    return UpdateConversationTitleDtoFromJSONTyped(json, false);
}

export function UpdateConversationTitleDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateConversationTitleDto {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'] == null ? undefined : json['title'],
    };
}

export function UpdateConversationTitleDtoToJSON(json: any): UpdateConversationTitleDto {
    return UpdateConversationTitleDtoToJSONTyped(json, false);
}

export function UpdateConversationTitleDtoToJSONTyped(value?: UpdateConversationTitleDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
    };
}

